// extracted by mini-css-extract-plugin
var _1 = "webpack-components-admin-Reviewers-DeleteReviewerWithConfirmationModal-module__bold";
var _2 = "webpack-components-admin-Reviewers-DeleteReviewerWithConfirmationModal-module__deleteButton";
export { _1 as "bold", _2 as "deleteButton" }
